import React from "react"

function getPrice(priceString, currency) {
  const num = parseFloat(priceString)
  if (isNaN(num) || num <= 0) {
    return "-"
  }

  const numAsString = Math.floor(num).toString()

  const withSeparators = numAsString
    .split("")
    .reverse()
    .map((char, i) => (i % 3 == 2 ? " " + char : char))
    .reverse()
    .join("")

  return `${withSeparators} ${currency}`
}

function PricingTable({ i18n, variants, locale, currencyTags }) {
  if (variants.length === 0) {
    return null
  }

  const currency = currencyTags[locale]

  const pricingGroups = variants[0].color_groups

  let partsPrices = []
  if (pricingGroups[0]) {
    partsPrices = pricingGroups[0].parts_prices
  }
  partsPrices.sort(
    (a, b) => (a.group?.position ?? 0) - (b.group?.position ?? 0),
  )

  return (
    <div className="pricing-table-wrapper">
      <table>
        <tbody>
          <tr className="pricing-top-row">
            <td key="head">{i18n.color_variant}</td>
            {pricingGroups.map((variant) => (
              <td key={variant.id}>
                <div className="pricing-table-img-wrapper">
                  {variant.colors.map((c) => (
                    <img key={c} className="pricing-table-img" src={c} />
                  ))}
                </div>
              </td>
            ))}
          </tr>
          {partsPrices.map(({ group }) => (
            <tr key={group.id}>
              <td key="head">{group.name}</td>
              {pricingGroups.map((variant) => (
                <td key={variant.id}>
                  {getPrice(
                    variant.parts_prices.find(
                      (priceRecord) => priceRecord.group.id === group.id,
                    ).price,
                    currency,
                  )}
                </td>
              ))}
            </tr>
          ))}
          <tr>
            <td key="head">{i18n.handles_price}</td>
            {pricingGroups.map((variant) => (
              <td key={variant.id}>
                {getPrice(variant.handles_price, currency)}
              </td>
            ))}
          </tr>
          <tr className="pricing-bottom-row">
            <td key="head">{i18n.sum.toLocaleUpperCase()}</td>
            {pricingGroups.map((variant) => (
              <td key={variant.id}>{getPrice(variant.price, currency)}</td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  )
}

export default PricingTable
